import React from "react";

/**
 * 创建context
 *
 * create by hy ON 2019/5/29
 */

const RouterContext = React.createContext("#80354d");

export default RouterContext;